import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for M501 (正常產品異動調整核准)
// ============================================================

export interface CandidateItem {
  fm110_01: string;       // 調整單號
  fm110_11: string | null; // 異動日期
  fm110_13: string;       // 庫位名稱（F105 lookup）
  fm110_15: string;       // 輸單人員名稱（F901 lookup）
  fm110_16: string;       // 部門代號
  fm110_17: string;       // 異動類別
  fm110_21: boolean;      // 異常旗標
  fm110_22: string;       // 處理對策（可編輯）
  fm110_80: string;       // 核准狀態（""=未核准, "P"=已核准）
}

export interface CandidateListResponse {
  items: CandidateItem[];
  total: number;
}

export interface ApproveItem {
  adj_no: string;       // FM110_01 調整單號
  action_taken: string; // FM110_22 處理對策（回寫）
}

export interface ApproveRequest {
  items: ApproveItem[];
  confirmed: boolean;
}

export interface ApproveResultItem {
  adj_no: string;
  success: boolean;
  message?: string;
}

export interface ApproveResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const m501Api = {
  /** List pending-approval adjustment orders by range */
  async listCandidates(params: {
    startNo?: string;
    endNo?: string;
  }): Promise<CandidateListResponse> {
    const res = await apiClient.get('/api/m501/candidates', { params });
    return res.data;
  },

  /** Batch approve selected adjustment orders */
  async approve(req: ApproveRequest): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/m501/approve', req);
    return res.data;
  },
};
